import LegalPage from './LegalPage.js';

export default function PrivacyPolicyPage() {
  return (
    <LegalPage title="Privacy policy">
      <p>
        DriftCal (operated by ADV Solutions, Australia) provides a drift event calendar
        at driftcal.net. This policy explains what we collect and how we use it.
      </p>

      <h2 className="text-lg font-semibold text-white pt-2">Information we collect</h2>
      <ul className="list-disc pl-5 space-y-2">
        <li>
          <strong className="text-white">Account:</strong> name, email address, and a
          password hash if you register with email. We do not store your raw password.
        </li>
        <li>
          <strong className="text-white">Google or Facebook sign-in:</strong> if you
          choose those buttons we receive a verified identifier and (when you allow it)
          your name and email from that provider, and we link them to your DriftCal
          account.
        </li>
        <li>
          <strong className="text-white">Calendar use:</strong> saved events, promoter or
          partner details you submit, and optional partner marketing opt-in.
        </li>
        <li>
          <strong className="text-white">Technical:</strong> essential cookies for sign-in
          and site function. If you accept analytics cookies we use Google Analytics and
          Facebook App Events to see which pages are used.
        </li>
      </ul>

      <h2 className="text-lg font-semibold text-white pt-2">How we use it</h2>
      <p>
        We use this information to run the calendar, keep you signed in, show events,
        process partner and promoter features, send transactional email (for example
        password reset or API keys), and improve the site. We do not sell personal
        information.
      </p>

      <h2 className="text-lg font-semibold text-white pt-2">Sharing</h2>
      <p>
        Hosting, database, email, and payment processing run on our service providers
        (including Amazon Web Services and Stripe where you subscribe). Google or
        Facebook only receive what you send them when you use their sign-in button.
        The public API does not include personal contact details.
      </p>

      <h2 className="text-lg font-semibold text-white pt-2">Cookies</h2>
      <p>
        Essential cookies are required for the site to work. Analytics cookies are
        optional and are set only if you choose Accept All on the cookie banner. You
        can refuse analytics and still use DriftCal.
      </p>

      <h2 className="text-lg font-semibold text-white pt-2">Retention and your choices</h2>
      <p>
        We keep account data while the account exists. You can ask us to update or
        delete your account by emailing{' '}
        <a className="text-white underline" href="mailto:contact@shopadv.net">
          contact@shopadv.net
        </a>
        .
      </p>

      <h2 className="text-lg font-semibold text-white pt-2">Contact</h2>
      <p>
        ADV Solutions —{' '}
        <a className="text-white underline" href="mailto:contact@shopadv.net">
          contact@shopadv.net
        </a>
        . Also see our{' '}
        <a className="text-white underline" href="/termsofservice">
          terms of service
        </a>
        .
      </p>
    </LegalPage>
  );
}
